export const selectCompanyConfigurationTypes = state =>
  state.configuration.configurationTypes
export const selectCompanyConfigurations = state => state.configuration.configurations
export const selectCompanyFELConfiguration = state => state.configuration.configFEL
